import React, { Component } from 'react';

import './H2.css';

class H2 extends Component {
    render() {
        return <h2>{this.props.children}</h2>;
    }
}

export default H2;



// WEBPACK FOOTER //
// ./src/components/h2/H2.jsx